import { Marker, GoogleMap, useLoadScript } from '@react-google-maps/api';
import MapDirectionsRenderer from './MapDirectionsRendered';
import config from '../../../../../../../application/config/config';

const libraries = ['places'];

function CustomMap(props) {
    const containerStyle = {
        width: '100%',
        height: '500px',
    };

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: config.gmaps_key,
        libraries,
    });

    return (
        isLoaded && (
            <GoogleMap
                mapContainerStyle={containerStyle}
                zoom={12}
                center={
                    props.places.length > 1
                        ? undefined
                        : {
                              lat: props.places[0].latitude,
                              lng: props.places[0].longitude,
                          }
                }
            >
                {props.places.map((marker, index) => {
                    const position = {
                        lat: marker.latitude,
                        lng: marker.longitude,
                    };
                    return <Marker key={index} position={position} />;
                })}
                {props.places.length > 1 && (
                    <MapDirectionsRenderer
                        places={props.places}
                        travelMode="DRIVING"
                    />
                )}
            </GoogleMap>
        )
    );
}

export default CustomMap;
